import { convertStyleValue } from '../../utils/js-style-to-css';
var maxWidthPropsToCss = function maxWidthPropsToCss(_ref) {
  var maxWidth = _ref.maxWidth,
    center = _ref.center;
  return "\n    ".concat("max-width: ".concat(convertStyleValue(maxWidth), ";"), "\n    ", "margin: ".concat(center ? 'auto' : '0'), "\n  ");
};
export default maxWidthPropsToCss;